import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/shared/ui';

import styles from './CatalogRetry.module.scss';

type Props = {
  className?: string;
  onRetry: () => void;
};

export const CatalogRetry: FC<Props> = ({ className, onRetry }) => (
  <Button
    variant="secondary"
    size="medium"
    className={cn(styles.retry, className)}
    onClick={onRetry}
  >
    <FormattedMessage
      id="workspace.retryCatalog"
      defaultMessage="Could not load document sets. Retry"
    />
  </Button>
);
